import React, { ElementType } from "react";
import { ModalBody, ModalFooter, ModalTitle } from "./ModalContent";
import { ModalContextProvider } from "./ModalContext";
import ModalHeader from "./ModalHeader";

interface ModalProps {
  show?: boolean;
  onHide?: () => void;
  className?: string;
  children: React.ReactNode;
  as?: ElementType;
  id?: string;
  dialogClassName?: string;
}

const Modal = ({
  show,
  onHide,
  children,
  className,
  id,
  dialogClassName,
  as: Component = "div",
  ...props
}: ModalProps) => {
  return (
    <React.Fragment>
      <div
        {...props}
        id={id || "defaultModal"}
        className={`${className} ${!show ? "show hidden" : ""}`}
      >
        <ModalContextProvider
          show={show}
          onHide={
            onHide ||
            (() => {
              /* No action needed */
            })
          }
        >
          <Component className={dialogClassName || ""}>{children}</Component>
        </ModalContextProvider>
      </div>
      <button
        type="button"
        onClick={onHide}
        className={`fixed inset-0 bg-slate-900/40 dark:bg-zink-800/70 z-[1049] backdrop-overlay border-0 ${
          !show ? "hidden" : ""
        }`}
        id="backDropDiv"
        aria-label="Fechar modal"
      />
    </React.Fragment>
  );
};

export default Object.assign(Modal, {
  Header: ModalHeader,
  Title: ModalTitle,
  Body: ModalBody,
  Footer: ModalFooter,
});
